import { TurboMount } from 'turbo-mount';
import { registerComponent as _registerComponent } from 'turbo-mount/react';
import type { ComponentType } from 'react';

const turboMount = new TurboMount();

// Widen component type — turbo-mount passes props from DOM data attributes at runtime
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const registerComponent = (tm: TurboMount, name: string, component: ComponentType<any>) =>
  _registerComponent(tm, name, component as ComponentType);

export default turboMount;
export { registerComponent };
